/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

import store from './store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [{
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Panel Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Resumen',
                active: true
              },
            ],
            pageTitle: 'Inicio',
          }
        },

        {
          path: '/ordenes/por-enviar',
          name: 'ordenes-por-enviar',
          component: () => import('./views/Orders/OrdersPending.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Órdenes',
                active: true
              },
              {
                title: 'Por Enviar',
                active: true
              }
            ],
            pageTitle: 'Órdenes de Mercadolibre',
          }
        },
        {
          path: '/ordenes/procesadas',
          name: 'ordenes-procesadas',
          component: () => import('./views/Orders/OrdersProcessing.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Órdenes',
                active: true
              },
              {
                title: 'Procesadas',
                active: true
              }
            ],
            pageTitle: 'Órdenes Procesadas',
          }
        },

        {
          path: '/ordenes/invalidas',
          name: 'ordenes-invalidas',
          component: () => import('./views/Orders/OrdersInvalid.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Órdenes',
                active: true
              },
              {
                title: 'Inválidas',
                active: true
              }
            ],
            pageTitle: 'Ordenes Inválidas',
          }
        },

        {
          path: '/ordenes/desestimadas',
          name: 'ordenes-desestimadas',
          component: () => import('./views/Orders/OrdersArchived.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Órdenes',
                active: true
              },
              {
                title: 'Desestimadas',
                active: true
              }
            ],
            pageTitle: 'Órdenes Desestimadas',
          }
        },

        {
          path: '/flete-dinamico/publicaciones',
          name: 'flete-dinamico-publicaciones',
          component: () => import('./views/DynamicFreight/Publications.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Flete Dinamico',
                active: false
              },
              {
                title: 'Publicaciones',
                active: true
              }
            ],
            pageTitle: 'Publicaciones',
          }
        },
        {
          path: '/catalogo',
          name: 'catalogo',
          component: () => import('./views/Catalog/Index.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Catálogo',
                active: false
              },
              {
                title: 'Publicaciones',
                active: true
              }
            ],
            pageTitle: 'Catálogo',
          }
        },

        {
          path: '/flete-dinamico/configuracion',
          name: 'flete-dinamico-configuracion',
          component: () => import('./views/DynamicFreight/Configuration.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Flete Dinamico',
                active: false
              },
              {
                title: 'Configuracion',
                active: true
              }
            ],
            pageTitle: 'Configuracion',
          }
        },
        {
          path: '/flete-dinamico/sucursales-configuracion',
          name: 'flete-dinamico-sucursales-configuracion',
          component: () => import('./views/DynamicFreight/BranchesSettings.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Flete Dinamico',
                active: false
              },
              {
                title: 'Sucursales',
                url: '/flete-dinamico/sucursales',
                active: true,
              },
              {
                title: 'Configuración',
                active: true
              },
            ],
            pageTitle: 'Sucursales',
          }
        },
        {
          path: '/flete-dinamico/sucursales',
          name: 'flete-dinamico-sucursales',
          component: () => import('./views/DynamicFreight/Branches.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Flete Dinamico',
                active: false
              },
              {
                title: 'Sucursales',
                active: true
              }
            ],
            pageTitle: 'Sucursales',
          }
        },
        {
          path: '/conexiones',
          name: 'conexiones',
          component: () => import('./views/Conections.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Conexiones',
                active: true
              },
              {
                title: 'Detalle',
                active: true
              }
            ],
            pageTitle: 'Conexiónes',
          }
        },

        {
          path: '/cuenta',
          name: 'cuenta',
          component: () => import('./views/Account.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Cuenta',
                active: true
              },
              {
                title: 'Detalle',
                active: true
              }
            ],
            pageTitle: 'Cuenta',
          }
        },

      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [{
          path: '/guest',
          name: 'guest-page',
          component: () => import('@/views/pages/Guest.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        // Ruta especial para iniciar el login desde CDS 
        {
          path: '/cds-start-login',
          name: 'cds-start-login',
          component: () => import('./components/StartCDSLogin.vue')
        },
        {
          path: '/branches-verification',
          name: 'branches-verification',
          component: () => import('@/views/pages/BranchesVerifications.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    },

    // Ruta especial para iniciar el login desde CDS 
    /*{
      path: '/cds-start-login',
      name: 'cds-start-login',
      component: () => import('./components/StartCDSLogin.vue')
    }*/
  ],
})

const unguardedRoutesNames = ['guest-page', 'page-error-404', 'cds-start-login'];

router.beforeEach(async (to, from, next) => {
  console.log('----- beforeEach ----- ');
  // Visiting Guarded Routes:
  if (unguardedRoutesNames.indexOf(to.name) < 1) {
    if (!store.state.authUser.id) { // If no user is set, try to load it, redirect
      console.log('router - no user in store')
      /*await*/
      store.dispatch('attemptLoadUser');
    }
    // Check Meli connection
    /*console.log('store.state.authUser.meli_id', store.state.authUser.meli_id);
    console.log(to, from);
    if(!store.state.authUser.meli_id && (
      to.name!='conexiones' 
      //&& from.name!='conexiones' 
      ) ){
      // No tiene meli conectado 
      console.log('No tiene meli conectado ');
      //next(false);
      next('/conexiones')
      if(from.name!='conexiones'){ router.push('/conexiones')}
    } */
  }

  next();

})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
